import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AdminService } from '../../../../services/admin.service';
import { OverlayService } from '../../../../services/overlay.service';
import { BasedatareportService } from 'src/app/services/basedatareport.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {
  /**
   * All Export Jobs
   */
  jobTypes = [];
  /**
   * All Jobs
   */
  history = [];
  /**
   * the Data to be shown
   */
  dataSource: MatTableDataSource<any>;
  /**
   * The Columns  of the Table
   */
  displayedColumns = ['number', 'type', 'name', 'size', 'lastModified', 'menu'];
  /**
   * constructor
   * @param adminService 
   * @param overlayService 
   * @param basedatareportService 
   */
  constructor(
    private adminService: AdminService,
    private overlayService: OverlayService,
    private basedatareportService: BasedatareportService) { }

    /**
     * ngOnInit
     */
  ngOnInit() {
    this.adminService.getExportJobs().subscribe(jobTypes => {
      this.jobTypes = jobTypes;
    });

    this.adminService.getExportJobHistory().subscribe(jobs => {
      this.history = jobs;
      this.dataSource = new MatTableDataSource(jobs)
    });
  }
  /**
   * Start the Export Job
   * @param type 
   */
  startJob(type) {
    this.adminService.startExport(type).subscribe(res => {
      this.overlayService.openSnackBar('Export wurde erfolgreich gestartet.')
    });
  }
  /**
   * Download the Report 
   * @param report 
   */
  downloadReport(report) {
    this.basedatareportService.downloadReport(report).subscribe((reportFile) => {
      const contentType = 'application/octet-stream';
      const blob = new Blob([reportFile], { type: contentType });
      const objectUrl: string = URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      a.href = objectUrl;
      a.download = report;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl)
    })
  }


}
